var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"c-message-fade"}},[(_vm.visible)?_c('div',{staticClass:"c-message",class:("c-message--" + _vm.type),on:{"click":_vm.close}},[_c('span',{staticClass:"c-message__text"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }